<div class="mobile-topbar">
  <button class="hamburger-btn" (click)="triggerOpenSidebar()" aria-label="Open course menu">
    <i class="bi bi-list"></i>
  </button>
  <span class="mobile-course-title">{{ courseTitle }}</span>
</div>
<div class="top-navbar">
  <div class="tabs-container">
	<ng-container *hasPermission="PermissionForStudents.COURSE_VIEW">
    <button
      class="tab"
      [routerLink]="['course-description']"
      routerLinkActive="active-tab">
      <i class="bi bi-book"></i>
      Lesson
    </button>
	</ng-container>

	<ng-container *hasPermission="PermissionForStudents.QUIZ_VIEW">
    <button
      class="tab"
      [routerLink]="['quiz-list']"
      routerLinkActive="active-tab">
      <i class="bi bi-trophy"></i>
      Quiz Challenge
    </button>
	</ng-container>
  </div>
</div>